module.exports = __webpack_public_path__ + "static/img/ottawa3.f3c29b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/ottawa3.jpg
// module id = 119
// module chunks = 9